export const environment = {
    production: false,
    keycloakBaseUrl: 'https://sso.preprod.services.utimaco.com',
    keycloakRealm: 'Utimaco-Portal-PREPROD',
    keycloakClientId: 'TaasEkmOpsportalFrontend',
    userManagementRestApiBasePath: 'https://sm-api.preprod.services.utimaco.com/taas/sm/api/',
    taasPortalFrontendUrl: 'https://portal.preprod.services.utimaco.com'
};